import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Merchant } from 'src/app/api/openapi';
import { useEffect, useRef, useState } from 'react';
import { MerchantClient } from 'src/app/api/clients/merchants';

const SelectMerchant = ({ selectedMerchantId, setSelectedMerchantId }: any) => {
  const [merchants, setMerchants] = useState<Merchant[]>([]);
  const cursor = useRef<string | undefined>(undefined);

  useEffect(() => {
    MerchantClient.catalogMerchantsListMerchants(
      'name',
      10,
      cursor.current
    ).then(({ data }) => {
      cursor.current = data.cursor;
      setMerchants(data?.items || []);
    });
  }, [cursor]);

  return (
    <FormControl>
      <InputLabel id="select-merchant">Select a Merchant</InputLabel>
      <Select
        value={selectedMerchantId}
        onChange={({ target }) => setSelectedMerchantId(target.value)}
        labelId="select-merchant"
        sx={{ minWidth: 200 }}
      >
        {merchants.map((merchant) => (
          <MenuItem value={merchant.merchant_id}>{merchant.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectMerchant;
